function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldtick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2592",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.932,
    height: 40,
    viewBox: "0 0 35.932 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49658",
    d: "M35.8 5.236a3.992 3.992 0 0 1 3.134 3.992v8.044a26.309 26.309 0 0 1-16.571 24.433 3.992 3.992 0 0 1-2.795 0A26.309 26.309 0 0 1 3 17.273V9.148a3.992 3.992 0 0 1 3.134-3.992l13.973-3.094a3.573 3.573 0 0 1 1.717 0z",
    transform: "translate(-2.999 -1.958)",
    style: {
      fill: "#00e298"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49658",
    d: "M27.751 4.432a3.013 3.013 0 0 1 2.365 3.013v6.071a19.855 19.855 0 0 1-12.5 18.439 3.013 3.013 0 0 1-2.109 0A19.855 19.855 0 0 1 3 13.516V7.384a3.013 3.013 0 0 1 2.365-3.012L15.91 2.037a2.7 2.7 0 0 1 1.3 0z",
    transform: "translate(1.408 2.642)",
    style: {
      fill: "#11243e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49660",
    d: "M13.391 19.176a1.66 1.66 0 0 1-1.162-.465l-3.784-3.717a1.661 1.661 0 0 1 2.34-2.357l2.622 2.573 6.821-6.639a1.667 1.667 0 1 1 2.34 2.373l-7.983 7.851a1.66 1.66 0 0 1-1.194.381z",
    transform: "translate(3.241 5.697)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldtick);
export default __webpack_public_path__ + "static/media/shieldtick.8a160b445c91fde30a68c7b0740e135f.svg";
export { ForwardRef as ReactComponent };